<template>
  <div v-if="!loading">
    <base-shell :title="pageMeta.title" :description="pageMeta.description" :hideSidebar="true">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </base-shell>

    <van-popup safe-area-inset-bottom style="background: transparent;" v-model="show">
      <div class="vipimgbox">
        <img style="width: 330px" src="@/assets/img/vipPost.png" alt="" />
        <div @click.stop="backvip" class="btn"></div>
        <div @click.stop="show = false" class="close"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { wxuser, getFreeFTVip } from '@/api/base';
import { asyncIsVip } from '@/utils/isVip';
import BaseShell from './BaseShell.vue';
import { getPcPageMeta } from './utils';

export default {
  name: 'PcMainPost',
  components: {
    BaseShell,
  },
  data() {
    return {
      loading: false,
      show: false,
    };
  },
  computed: {
    pageMeta() {
      return getPcPageMeta(this.$route);
    },
  },
  created() {
    this.getUserinfo();
  },
  methods: {
    getUserinfo() {
      this.loading = true;
      wxuser().then(res => {
        if (res.data.wxUser.isReceiveFt == 0) {
          this.show = true;
        } else if (this.$route.path != '/postView') {
          // 继续沿用原有会员校验逻辑，避免 PC 端和移动端行为分叉。
          asyncIsVip(2, 'noFetch', res);
        }
        this.loading = false;
      });
    },
    backvip() {
      getFreeFTVip().then(() => {
        this.$toast('恭喜您领取成功！');
        this.show = false;
      });
    },
  },
};
</script>

<style scoped>
.vipimgbox {
  position: relative;
  width: 330px;
}

.vipimgbox img {
  display: block;
  width: 100%;
  height: auto;
}

.vipimgbox .btn {
  width: 200px;
  height: 40px;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
}

.vipimgbox .close {
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: 0;
  left: 53%;
  transform: translateX(-50%);
}
</style>
